var map = {
	"./1.png": 1531,
	"./2.png": 1532,
	"./3.png": 1533,
	"./4.png": 1534,
	"./5.png": 1535,
	"./6.png": 1536,
	"./7.png": 1537,
	"./8.png": 1538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1530;